export default __webpack_public_path__ + "static/media/settingsaccountdetails.895eb756.svg";